// cleanup_convert_to_typescript_file_GENERICS

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import classnames from 'classnames';

import { Button, PRIMARY, TERTIARY } from '@glu/buttons-react';

import useLocale from 'components/useLocale';
import constants from 'utils/constants';
import { clearGrids as clearGrid } from 'logic/store/grids/actions';
import { getUserSessionInfo } from 'api/user/service';
import { unsubscribeComponent } from 'utils/unsubscribeComponent';
import { setCurrentUser as setUser, logout as signOut } from 'logic/store/authentication/actions';
import Workflow from 'components/workflow/Workflow';

import ResetPassword from './ResetPassword';
import useStyles from './resetPassword.styles';

const subscriptions = {
  userInfo: null
};

export const ResetPasswordPageComponent = ({ returnUrl, user, ...rest }) => {
  const history = useHistory();
  const locale = useLocale();
  const { wrapper } = useStyles();
  const dispatch = useDispatch();

  useEffect(() => () => unsubscribeComponent(subscriptions), []);

  const setCurrentUser = (...params) => {
    dispatch(setUser(...params));
  };

  const logout = (...params) => dispatch(signOut(...params));

  const clearGrids = () => clearGrid(dispatch);

  const onSuccess = () => {
    setCurrentUser({ ...user, showPasswordExpirationWarning: false });
    subscriptions.userInfo = getUserSessionInfo(user.authenticationId).subscribe(
      ({ data }) => {
        setCurrentUser(data);
      },
      (error) => {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    );
    return history.push({
      pathname: constants.WORKSPACES.DASHBOARD
    });
  };

  const resetPwdProps = {
    ...rest,
    clearGrids,
    logout,
    setCurrentUser
  };
  const header = locale[user.tempPassword ? 'common.resetPassword' : 'function.ChangePwd'];
  const homeUrl = !user.tempPassword || null;
  const goBack = returnUrl && homeUrl && '/';

  return (
    <Workflow title={header} returnUrl={goBack}>
      <div className={classnames(wrapper, 'row')}>
        <div className="col-xs-12 col-md-8 no-gutters">
          <ResetPassword
            onSuccess={onSuccess}
            user={{ ...user, password: user.tempPassword }}
            actions={({ allPassing, sending }) => (
              <div>
                <Button
                  variant={PRIMARY}
                  disabled={!allPassing || sending}
                  className="btn btn-primary"
                  type="submit"
                  data-qa="change-password"
                >
                  {locale['common.change']}
                </Button>
                {goBack && (
                  <Link to={goBack} className="btn btn-link" disabled={sending} type="button">
                    {locale['common.cancel']}
                  </Link>
                )}
                {!goBack && (
                  <Button
                    onClick={logout}
                    variant={TERTIARY}
                    className="btn btn-link"
                    disabled={sending}
                    data-qa="cancel-change-password"
                  >
                    {locale['common.cancel']}
                  </Button>
                )}
              </div>
            )}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...resetPwdProps}
          />
        </div>
      </div>
    </Workflow>
  );
};

ResetPasswordPageComponent.defaultProps = {
  returnUrl: true,
  user: {}
};

ResetPasswordPageComponent.propTypes = {
  returnUrl: PropTypes.bool,
  user: PropTypes.shape({
    userCode: PropTypes.string,
    customerCode: PropTypes.string
  })
};

export default ResetPasswordPageComponent;
